export const expandAccordian = state => {
  const accordian = document.getElementsByClassName('c-m-accordion__control');
  if (state.accountDetailsEdit) {
    accordian[0].click();
  }
  if (state.mandateEdit) {
    accordian[1].click();
  }
};

export const isAnyAccordianCollapsed = state => state.accountDetailsEdit || state.mandateEdit;
